import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { IExplodeEmojiProps } from "interfaces";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const AnimatedEmoji = dynamic(() => import("./animatedEmoji/AnimatedEmoji"));

const ExplodeEmoji = ({ codes, direction }: IExplodeEmojiProps) => {
    const [emojiBucket, setEmojiBucket] = useState<{ code: string; id: number }[]>([]);
    const [shuffledEmojiBucket, setShuffledEmojiBucket] = useState<{ code: string; id: number }[]>([]);
    const [timeoutIds, setTimeoutIds] = useState<any[]>([]);
    const { config } = useAppSelector(({ videoData: { config } }) => ({ config }), shallowEqual);

    const RetrievalAndShuffle = () => {
        let ShuffleEmoji = codes
            .map((a) => ({
                sort: Math.random(),
                value: a
            }))
            .sort((a, b) => a.sort - b.sort)
            .map((a) => a.value)
            .map((item, i) => ({ code: item, id: i }));
        setShuffledEmojiBucket(ShuffleEmoji);
    };

    useEffect(() => {
        setShuffledEmojiBucket([]);
        setEmojiBucket([]);
        RetrievalAndShuffle();
    }, [codes]);

    useEffect(() => {
        let timeoutId: any;
        if (shuffledEmojiBucket.length > 0) {
            for (let i = 0; i < shuffledEmojiBucket.length; i++) {
                timeoutId = setTimeout(() => {
                    setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[i]]);
                }, (config.get_interval / shuffledEmojiBucket.length) * 500 * i);
                setTimeoutIds((prev) => [...prev, timeoutId]);
            }
        }
        return () => {
            if (timeoutIds.length > 0) {
                timeoutIds.forEach((id) => clearTimeout(id));
                setTimeoutIds([]);
            }
        };
    }, [shuffledEmojiBucket]);
    return (
        <div>
            {emojiBucket.length > 0 ? (
                emojiBucket.map((item, index) => {
                    return (
                        <div key={index}>
                            <AnimatedEmoji direction={direction} emojiCode={item.code} />
                        </div>
                    );
                })
            ) : (
                <></>
            )}
        </div>
    );
};

export default ExplodeEmoji;
